/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'report': 'Bericht | Berichte'
  },

  /* english */
  en: {
    'report': 'Report | Reports'
  }
}
